import { render, staticRenderFns } from "./Slogan.vue?vue&type=template&id=80ca4bc6&scoped=true&"
import script from "./Slogan.vue?vue&type=script&lang=js&"
export * from "./Slogan.vue?vue&type=script&lang=js&"
import style0 from "./Slogan.vue?vue&type=style&index=0&id=80ca4bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ca4bc6",
  null
  
)

export default component.exports